import { ListItem } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { fontSize, palette } from '../../..';

interface EmailCardProps {
  id: string;
  name: string;
  handleDelete: () => void;
  chartControls: any;
  propKey: string;
}

const EmailCard = ({ id, name, handleDelete, chartControls, propKey }: EmailCardProps) => {
  const CancelIcon = () => {
    return (
      <CloseRoundedIcon
        onClick={handleDelete}
        sx={{
          fontSize: fontSize.medium,
          cursor: 'pointer',
          color: palette.primary.contrastText,
          '&:hover': {
            color: 'red',
            transform: 'scale(1.1)',
          },
        }}
      />
    );
  };

  return (
    <ListItem sx={{ padding: '0px' }}>
      <div
        className="axisFilterField"
        style={{
          border: '1px solid grey',
          borderRadius: '5px',
          paddingLeft: '0.3rem',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          height: '1.5rem',
          width: '100%',
          gap: '0.2rem',
          boxSizing: 'border-box',
          marginTop: '6px',
        }}
      >
        <CancelIcon />
        <span
          style={{
            lineHeight: '15px',
            fontSize: fontSize.medium,
            color: palette.primary.contrastText,
          }}
        >
          {name}
        </span>
      </div>
    </ListItem>
  );
};

export default EmailCard;
